import React, { forwardRef } from 'react';

const TONE_CLASS = {
  default: 'badge',
  primary: 'badge badge-primary',
  success: 'badge badge-success',
  lime: 'badge badge-lime',
  warning: 'badge badge-warning',
  orange: 'badge badge-orange',
  error: 'badge badge-error',
};

/**
 * @param {object} props
 * @param {'default'|'primary'|'success'|'lime'|'warning'|'orange'|'error'} [props.tone='default']
 * @param {string} [props.className]
 * @param {React.ReactNode} props.children
 */
const Badge = forwardRef(function Badge(
  { tone = 'default', className = '', children, ...rest },
  ref
) {
  const base = TONE_CLASS[tone] || TONE_CLASS.default;
  return (
    <span ref={ref} className={`${base} ${className}`.trim()} {...rest}>
      {children}
    </span>
  );
});

export default Badge;
